export class Factor_Rea{
    constructor(
        public _id: string,
        public tipo: String,
        public valor: Number,

    ){}
}